(ns ycweb.weber.table
  (:require
    #?@(:clj  [[clj-time.coerce :as tc]]
        :cljs [[cljs-time.coerce :as tc]])
    [ycweb.weber.form :as form]
    [ycweb.weber.elements :as elm]
    [rum.core :as rum]
    [ycweb.util.core :as u]
    [ycweb.util.date :as ud]
    [util.string :as str]))

;; TODO: This can do with a simpler implementation.

(rum/defc table-head [& cols]
  [:thead
   (into
     [:tr]
     (map
       (fn [i]
         [:th i])
       cols))])

(rum/defc table-foot [& cols]
  [:tfoot
   (into
     [:tr]
     (map
       (fn [i]
         [:th i])
       cols))])

(defn table-row [cols]
  (into [:tr] cols))

(rum/defc add-button [targetid]
  [:div.stdtable-addbutton
   [:button.stdtable-addbutton--button
    "+"
    [:span.addbutton-tooltip "Add"]]])

(rum/defc table-element
  [id colgroups head data & {:keys [foot template-row dynamic? default-length] :as options}]

  (let [tbl
        (into
          [:table.stdtable
           (u/maybe assoc
             {:id id
              :cellpadding 0 :cellspacing 0 :border 0}
             :data-default-length default-length
             :class (if dynamic? "dyntable"))]
          (concat
            [colgroups head]
            data
            [foot]))]
    (if template-row
      [:div
       tbl
       (add-button id)]

      tbl)))

(defn action [title url idfn & [class & {:as attrs}]]
  (fn [i]
    (if (or (nil? (:pred attrs)) ((:pred attrs) i))
      [:a
       (merge
         {:href (str url (if idfn (idfn i))) :class class}
         (dissoc attrs :pred))
       title])))

(defn toggle-action
  [truthy-title falsey-title pred
   url idfn & [{:as attrs}]]

  (fn [i]
    (let [truthy (pred i)]
      [:a
       (merge
         {:href (str url (if idfn (idfn i)))
          :class "toggle"
          :data-truthy truthy-title
          :data-falsey falsey-title
          :data-current truthy}
         attrs)
       (if truthy truthy-title falsey-title)])))

(defn quickview [url idfn & [title pred]]
  (action (or title "Quick View") url idfn "quickview" :pred pred))

(defn delete [url idfn & [confirm-msg title pred]]
  (action (or title "Delete") url idfn "delete" :confirm (or confirm-msg "Are you sure?") :pred pred))

(defn hide [& [url idfn title pred]]
  (action (or title "Hide") (or url "#") idfn "delete" :pred pred))

(defn table-checkbox [name id checked? & {:keys [checkall?]}]
  [:input
   (u/maybe assoc
     {:type "checkbox" :name name :id id
      :class (if checkall? "checkall" "checkrow")}
     :checked (if checked? "checked"))])

(defn line-checkbox [name idfn checkedfn]
  (fn [i]
    (table-checkbox
      (str name "[" (idfn i) "]") (str name (idfn i))
      (checkedfn i))))

(defn table-options [tableid & items]
  (into
    [:div {:class "tableoptions" :tableid tableid}]
    items))

(defn col [title key-fn & {:keys [type total-fn url-fn class-fn style-fn] :as opts}]
  (assoc opts :key-fn key-fn :title title))

(defn cols [& [[title key-fn & {:keys [type total-fn url-fn class-fn style-fn] :as opts}] :as colspec]]
  (vec (map #(apply col %) (remove nil? colspec))))

(defn cell [i content header & [attrs]]
  (let [ufn (:url-fn header)
        content (if ufn [(into [:a (u/maybe assoc {:href (ufn i)} :target (:target header))] content)] content)
        {:keys [class-fn style-fn tooltip-fn]} header]
    (into
      [:td.cell
       (cond-> (or attrs {})
         class-fn (assoc :class (class-fn i))
         style-fn (assoc :style (style-fn i))
         tooltip-fn (assoc :title (tooltip-fn i)))]
      content)))



;; TODO: need to work on the js equivalent of `class`
#?(:clj
   (defmulti coerce-int class)
   :cljs
   (defn coerce-int [i] (int i)))

#?(:clj
   (defmethod coerce-int Integer [i] i))

#?(:clj
   (defmethod coerce-int Long [i] i))

#?(:clj
   (defmethod coerce-int BigDecimal [i] (long i)))

#?(:clj
   (defmethod coerce-int String [i] (Long/parseLong i)))

#?(:clj
   (defmethod coerce-int :default [i] (long i)))

#?(:clj
   (defmulti coerce-double class)
   :cljs
   (defn coerce-double [i]
     (float i)))

#?(:clj
   (defmethod coerce-double Double [i] i))

#?(:clj
   (defmethod coerce-double String [i] (Double/parseDouble i)))

#?(:clj
   (defmethod coerce-double :default [i] (double i)))

(defmulti tablecell (fn [type val header item] type))

(defmethod tablecell :numeric [_ val header i]
  (cell i [(str/format "%d" (coerce-int (or val 0)))] header {:style {"text-align" "right"}}))

(defmethod tablecell :currency [_ val header i]
  (cell i [(str/format "%.2f" (coerce-double (or val 0)))] header {:style {"text-align" "right"}}))

(defmethod tablecell :actions [_ val header i]
  (cell i val header {:style "text-align:right"}))

(defmethod tablecell :default [_ val header i]
  (cell i [(if (coll? val) val (str val))] header))

(defmethod tablecell :image [_ val header i]
  (cell i [(when val [:img {:src val}])] header))

(defmethod tablecell :yesno [_ val header i]
  (cell i [(if val "Yes" "No")] header))


(defmethod tablecell :date [_ val header i]
  (cell i
    [[:span
      (ud/format-date (tc/to-date-time val) "dd MMM")
      [:br]
      (ud/format-date (tc/to-date-time val) "HH:mm")]]
    header))

(defmethod tablecell :date-sort [_ val header i]
  (cell i
    [[:span
      (ud/format-date (tc/to-date-time val) "YYYY-MM-dd")
      [:br]
      (ud/format-date (tc/to-date-time val) "HH:mm")]]
    header))


(defmethod tablecell :dateyr [_ val header i]
  (cell i [(ud/format-date (tc/to-date-time val) "dd MMM HH:mm YYYY")] header))

(defmethod tablecell :age [_ val header i]
  (cell i [(ud/age-string val)] header))

(defmethod tablecell :hours [_ val header i]
  (cell i [(ud/hours-string val)] header))

(defmethod tablecell :literal [_ val header i]
  (cell i [(:text header val)] header))

(defmethod tablecell :huge [_ val header i]
  (cell i [[:h2 val]] header))

(defmethod tablecell :input [_ val header i]
  (cell i
    [(form/input
       (:size header)
       ((:name-fn header) i) ((:id-fn header) i) val
       (:config header))] header))

(defmethod tablecell :input-short [_ val header i]
  (cell i [(form/input "small" ((:name-fn header) i) ((:id-fn header) i) val)] header))

(defmethod tablecell :input-tiny [_ val header i]
  (cell i [(form/input "tiny" ((:name-fn header) i) ((:id-fn header) i) val)] header))

(defmethod tablecell :select [_ val header i]
  (cell i
    [(apply form/select ((:name-fn header) i) ((:id-fn header) i) (:options header)
       :selected val (mapcat identity (:config header)))] header))

(defmethod tablecell :checkbox [_ val header i]
  (cell i
    [(form/checkbox ((:name-fn header) i) ((:id-fn header) i) (or (:value header) "1")
       ((:text-fn header (constantly (:text header))) i)
       val ((:disabled-fn header (constantly (:disabled header))) i))] header))

(defmethod tablecell :radio [_ val header i]
  (cell
    i
    [(form/radio
       ((:name-fn header (constantly (:name header))) i)
       ((:id-fn header) i)
       (if (:value-fn header)
         ((:value-fn header) i)
         (or (:value header) "1"))
       ((:text-fn header (constantly (:text header))) i)
       ((:selected-fn header) i)
       ((:disabled-fn header (constantly (:disabled header))) i))]
    header))

(defmethod tablecell :tags [_ val header i]
  (cell i
    [(form/tags ((:name-fn header) i) ((:id-fn header) i) val)] header))

(defmethod tablecell :fileload [_ val header i]
  (cell i
    [(form/fileupload ((:name-fn header) i) ((:id-fn header) i) val)] header))

(defmethod tablecell :date-picker [_ val header i]
  (cell i
    [(elm/datepicker ((:name-fn header) i) ((:id-fn header) i) val)] header))

(defmethod tablecell :barcode [_ val header i]
  (cell i
    [(elm/barcode val)] header))

(defmethod tablecell :barcode-alt [_ val header i]
  (let [t (:text header val)
        t (if (or (keyword? t) (fn? t)) (t i) t)]
    (cell i
      [(elm/barcode-text val t)] header)))

(defmethod tablecell :variation-image [_ val header i]
  (cell i [(when val [:img {:src (str "/variationimage/" val) :class "variationimage"}])] header))


(defmethod tablecell :longcurrency [_ val header i]
  (cell i
    [(str/format "%.2f" (/ (coerce-double (or val 0)) 100))]
    header
    {:style {"text-align" "right"}}))

(defmethod tablecell :percentage [_ val header i]
  (cell i [(str/format "%.1f%%" (* val 100))] header {:style {"text-align" "right"}}))

(defmethod tablecell :mass [_ val header i]
  (cell i [(str/format "%.2f" (/ (coerce-double (or val 0)) 1000))] header {:style {"text-align" "right"}}))

(defmethod tablecell :volume [_ val header i]
  (cell i [(str/format "%.2f" (/ (coerce-double (or val 0)) (* 1000 1000)))] header {:style {"text-align" "right"}}))





(defn add-checkboxes [headers checkbox-fn]
  (concat
    [(col
       (table-checkbox "" "" false :checkall? true)
       (line-checkbox "item" :id (or checkbox-fn (constantly false))))]
    headers))

(defn add-actions [headers actions]
  (concat headers [(col "" (fn [k] (into [:span] ((apply juxt actions) k))))]))

(defn build-footer-cols [headers data]
  (map
    (fn [{:keys [type total-fn key-fn] :as i}]
      (tablecell
        type
        (if total-fn (total-fn (map key-fn data)))
        {}
        data))
    headers))

(defn convert-row-data [headers]
  (fn [i]
    (map
      (fn [h]
        (tablecell (:type h) ((:key-fn h) i) h i)) headers)))

(defn hilite-fn [x]
  {"background-color" (:hilite x)})

(defn table [data headers & {:keys [foot? id dynamic? checkboxes? checkbox-fn actions default-length
                                    template-row]}]
  (let [headers (if checkboxes? (add-checkboxes headers checkbox-fn) headers)
        ;; Before adding the actions..
        tmplrowgen (comp table-row (convert-row-data headers))
        headers (if actions (add-actions headers (interpose (constantly " | ") actions)) headers)
        rowgen (comp table-row (convert-row-data headers))]
    (table-element
      (or id (name (gensym "tableauto")))
      (into [:colgroup] (map (fn [x] [:col {:class (str "con" x)}]) (take (count headers) (cycle [0 1]))))
      (apply table-head (map :title headers))
      (concat
        (map rowgen data)
        (if template-row
          [:template {:class "template-row"}
           (tmplrowgen template-row)]))
      :foot (if foot? [:tfoot (vec (concat [:tr] (build-footer-cols headers data)))])
      :dynamic? dynamic?
      :template-row template-row
      :default-length default-length)))


(defn avg [xs]
  (let [xs (map coerce-double (remove nil? xs))]
    (if (= (count xs) 0)
      0
      (/ (reduce + xs) (count xs)))))

(defn sum [xs]
  (reduce + (map coerce-int (remove nil? xs))))
